import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { formatApiError } from "../../lib/format";
import { Logo } from "../../components/Logo";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [storeInfo, setStoreInfo] = useState(null);

  React.useEffect(() => {
    if (checked && user) {
      navigate("/admin", { replace: true });
    }
  }, [checked, user, navigate]);

  React.useEffect(() => {
    api.get("/store-info").then((r) => setStoreInfo(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Berhasil masuk");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Gagal masuk");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9F6F0] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-[#E5DCC5] bg-white p-7 shadow-sm">
        <div className="flex justify-center"><Logo size={48} logoUrl={storeInfo?.logo_url} /></div>
        <h1 className="mt-5 text-center font-heading text-xl font-bold text-[#2C1E16]">Dashboard Admin</h1>
        <p className="mt-1 text-center text-sm text-[#8B7355]">Masuk untuk mengelola pesanan & produk</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="mb-1.5 block text-sm">Email</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="h-12 bg-white" required />
          </div>
          <div>
            <Label className="mb-1.5 block text-sm">Kata Sandi</Label>
            <div className="relative">
              <Input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password"
                className="h-12 bg-white pr-11"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Sembunyikan password" : "Tampilkan password"}
                className="absolute right-0 top-0 flex h-12 w-11 items-center justify-center text-[#8B7355] hover:text-[#2C1E16] transition-colors"
              >
                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
              </button>
            </div>
          </div>
          <Button type="submit" disabled={loading} data-testid="login-submit" className="h-12 w-full rounded-xl bg-[#8B5A2B] hover:bg-[#6B4423]">
            {loading ? "Memproses..." : "Masuk"}
          </Button>
        </form>
      </div>
    </div>
  );
}
